import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import SqftNavCustomBacksplashSegment from "./SqftNavCustomBacksplashSegment";

const SqftNavCustomBacksplashSection = (props) => {
  const {sectionName, backsplash, index} = props;

  return (
    <div className="mitered-section" data-id="${miteredSection.id}">
      <h3 className="content-header">
        {/*${TranslatesProvider.translate("sqft.navigation.mitered.title")}*/}
        {sectionName}
        <span className="text-inCircle">
               {('0' + (index + 1)).slice(-2)}
              </span>
      </h3>
      <div className="mitered-segments">
        {
          <SqftNavCustomBacksplashSegment key={index}
                                          backsplash={backsplash}
                                          index={index} />

        }
      </div>
    </div>
  )
};

SqftNavCustomBacksplashSection.propTypes = {
  sectionName: PropTypes.string,
  backsplash: PropTypes.object
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavCustomBacksplashSection);
